export default "__VITE_ASSET__CE3_nDK___"